import React from "react";
import { Card } from "../card";
import { Colors } from "../../Constants/colors";
import { KeyValueList } from "../KeyValueList";
import { getValue } from "../../utils/object.utils";
import { CapitalizeOnlyFirstLetter } from "../../Helper/string.helper";
import { AvatarSize, UserAvatar } from "../UserAvatar/UserAvatar";

interface Props {
  kidsInfo: object;
}

export const ChildrenCards = ({ kidsInfo }: Props) => {
  const transformedData = [
    {
      key: "Name",
      value: getValue(kidsInfo, "full_name", ""),
    },
    {
      key: "Gender",
      value: CapitalizeOnlyFirstLetter(getValue(kidsInfo, "gender", "")),
    },
    {
      key: "Regno",
      value: getValue(kidsInfo, "regno") || "N/A",
    },
    {
      key: "Roll no",
      value: getValue(kidsInfo, "roll_no") || "N/A",
    },
    {
      key: "Class",
      value: getValue(kidsInfo, "class.name"),
    },
  ];

  const avatar = getValue(kidsInfo, "avatar", "");

  return (
    <Card
      wrapperStyle={{
        backgroundColor: Colors.WhiteSmoke,
      }}
    >
      <div className="flex flex-row gap-8">
        <UserAvatar image={avatar} size={AvatarSize.sm} />
        <div
          style={{
            flex: 1,
          }}
        >
          <KeyValueList lists={transformedData} />
        </div>
      </div>
    </Card>
  );
};
